import { render } from "./SnippetSidebar.vue?vue&type=template&id=63a2e699&scoped=true"
import script from "./SnippetSidebar.vue?vue&type=script&lang=js"
export * from "./SnippetSidebar.vue?vue&type=script&lang=js"

import "./SnippetSidebar.vue?vue&type=style&index=0&id=63a2e699&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a2e699"]])

export default __exports__